import { customAlphabet } from "nanoid";
import { typedJson } from "./misc.js";
/**
 * Generate a new QR code.
 * @returns The QR code.
 */
export function generateQrCode() {
    return customAlphabet("abcdefghijklmnopqrstuvwxyzQBCDEFGHIJKLMNOPQRSTUVWXYZ0123456789")();
}
/**
 * Process a QR code as a string. If it's a URL, it strips off the last part.
 * @param input The input string.
 * @returns The QR code.
 */
export function processQrCodeAsString(input) {
    return input.split("/").at(-1) ?? input;
}
/**
 * Process a QR code as JSON. If it contains a barcode key, use that. Otherwise, process the entire string.
 * @param input The input string.
 * @returns The QR code.
 */
export function processQrCodeAsJson(input) {
    try {
        const json = typedJson(input);
        if (typeof json === "object" && json !== null) {
            if ("type" in json) {
                if (json["type"] === "isolationPoint") {
                    if ("barCode" in json) {
                        return json["barCode"]?.toString();
                    }
                    if ("qrCode" in json) {
                        return json["qrCode"]?.toString();
                    }
                }
            }
            if ("t" in json) {
                if (json["t"] === "ip") {
                    if ("c" in json) {
                        return json["c"]?.toString();
                    }
                }
            }
        }
    }
    catch (e) {
        return processQrCodeAsString(input);
    }
}
